module.exports = __webpack_public_path__ + "img/u1193.1f2a9a7d.svg";